// Entry: wires the chain API (window.LC) and live data (window.LIVE) into the page layer, then starts it.
import * as chain from './chain';
import { config } from './config';
import { LIVE } from './live';
import { mountPrivy, privyBridge } from './privy';

const LC = {
  ...chain,
  config,
  wallet: chain.currentWallet,
  async login(): Promise<boolean> {
    if (config.e2eKey) {
      chain.setTestWallet(config.e2eKey as `0x${string}`);
      return true;
    }
    return privyBridge.login();
  },
  async logout() {
    if (config.e2eKey) return chain.clearWallet();
    return privyBridge.logout();
  },
};

window.LC = LC;
window.LIVE = LIVE;
// The home hero's 3D scene (three.js) is its own chunk, fetched only when the hero decides to run it.
(window as unknown as { LISTED_HERO3D: () => Promise<unknown> }).LISTED_HERO3D = () => import('./hero3d');

const L = window.L;

// Keep the wrong-network flag in step with the wallet.
chain.onWallet(async (w) => {
  if (!w) return;
  try {
    L.state.settings.wrongNet = !(await chain.onRightChain());
    L.save();
  } catch {
    /* wallet not ready */
  }
});

async function boot() {
  if (!config.deployment) console.error(`[listed] no deployment for chain ${config.chainId}`);
  L.start();
  if (!config.e2eKey) mountPrivy();
  try {
    await LIVE.start();
  } catch (e) {
    console.error('[listed] live data', e);
    L.toast('Live data is offline. Retrying…', 'err');
  }
  L.refresh();
  L._paintNet();
}

boot();
